<span class="clipboard-copy">
  <span class="text">{{text}}</span>
  <fa-icon (click)="copyToClipboard()" [icon]="copyIcon"></fa-icon>
</span>